<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
    <div class="message" [innerHTML]="data.message">

    </div>
    <div class="buttons">
        <button mat-flat-button *ngFor="let action of data.actions" [color]="action.color" (click)="onClickAction(action.type)">{{action.text}}</button>
    </div>
</div>